import React from 'react'

const Charging = () => {
  return (
    <div>Charging</div>
  )
}

export default Charging